module.exports = __webpack_public_path__ + "img/icon1.c11cf5c8.png";